<svg width="48" height="28" viewBox="0 0 48 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="48" height="28" rx="4" fill="#006FCF" />
  <text
    x="24"
    y="18"
    fill="#FFFFFF"
    font-size="9.5"
    font-weight="900"
    font-family="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
    letter-spacing="0.8"
    text-anchor="middle"
  >
    AMEX
  </text>
</svg>
